import { IncidentInterface } from "../models/Incident";
import client from "./client";

class IncidentService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/incidents`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<IncidentInterface[]>(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/incidents/getbyid/${id}`;

      const { data } = await client.get<IncidentInterface>(url);

      return data;
    } catch (error) {
      throw error;
    }
  }

  async Save(ticket: IncidentInterface) {
    try {
      let url = `/api/incidents`;

      const { data } = await client.post<IncidentInterface>(url, ticket);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, ticket: IncidentInterface) {
    try {
      let url = `/api/incidents/update/${id}`;

      const { data } = await client.post<IncidentInterface>(url, ticket);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/incidents/remove/${id}`;
      await client.post<IncidentInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new IncidentService();
